import styled, {keyframes} from 'styled-components'

const slideDown = keyframes`
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`

const slideUp = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-100%);
        opacity: 0;
    }
`

const pulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.2);
        opacity: 0.7;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`

const expandIn = keyframes`
    from {
        transform: scale(0.8);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
`

// Collapsed state - small circle indicator
const CollapsedIndicator = styled.div`
	position: fixed;
	top: 12px;
	left: 12px;
	z-index: 9999;

	width: 24px;
	height: 24px;

	display: flex;
	align-items: center;
	justify-content: center;

	background-color: ${(props) => (props.$isMaxRetries ? '#dc3545' : '#f59e0b')};
	border-radius: 50%;

	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

	&:hover {
		transform: scale(1.15);
		box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
	}
`

const PulsingDot = styled.div`
	width: 10px;
	height: 10px;

	background-color: #fff;
	border-radius: 50%;

	animation: ${pulse} ${(props) => (props.$isMaxRetries ? '0.8s' : '1.5s')}
		ease-in-out infinite;
`

// Expanded state - full container
const Container = styled.div`
	position: fixed;
	top: 8px;
	left: 8px;
	width: fit-content;
	max-width: calc(100vw - 32px);
	z-index: 9999;

	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;

	padding: 12px 16px;
	border-radius: 8px;

	background-color: #dc3545;

	color: white;
	font-weight: 500;
	font-size: 14px;

	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	cursor: pointer;

	animation: ${expandIn} 0.2s ease-out;
`

const Icon = styled.span`
	font-size: 16px;
`

const Message = styled.span`
	white-space: nowrap;
	color: #fff;
`

const RefreshButton = styled.button`
	padding: 6px 12px;
	margin-left: 8px;

	background-color: #fff;
	color: #dc3545;

	border: none;
	border-radius: 4px;

	font-size: 12px;
	font-weight: 600;

	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background-color: #f8f9fa;
		transform: scale(1.02);
	}

	&:active {
		transform: scale(0.98);
	}
`

const CollapseHint = styled.span`
	font-size: 10px;
	opacity: 0.7;
	margin-left: auto;
	padding-left: 8px;
`

const Style = {
	Container,
	CollapsedIndicator,
	PulsingDot,
	Icon,
	Message,
	RefreshButton,
	CollapseHint,
}

export default Style
